import VTAPI from "../api/VTAPI";
import { validateResponseStatus } from "../utils";

export const postContactUs = async (body) => {
  const result = await VTAPI()
    .post("/ContactUs", body)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  return result.data;
};

export const getTypes = async (language) => {
  const result = await VTAPI()
    .get(`/ContactUs/Types/${language}`)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data;
  } else {
    return [];
  }
};
